module.exports = __webpack_public_path__ + "assets/img/img4-596f38d9.png";